import card5Looks from '../assets/images/outfits-montage-icons/card-5-looks.png';
import card10Looks from '../assets/images/outfits-montage-icons/card-10-looks.png';
import card15Looks from '../assets/images/outfits-montage-icons/card-15-looks.png';

export const outfitsMontageData = [
  {
    id: 1,
    serviceImage: card5Looks,
    serviceName: 'Montagem de 5 looks',
    originalPrice: 1990,
    creditPrice: 990,
    pixPrice: 990,
  },
  {
    id: 2,
    serviceImage: card10Looks,
    serviceName: 'Montagem de 10 looks',
    originalPrice: 2990,
    creditPrice: 1990,
    pixPrice: 1990,
  },
  {
    id: 3,
    serviceImage: card15Looks,
    serviceName: 'Montagem de 15 looks',
    originalPrice: 3990,
    creditPrice: 2990,
    pixPrice: 2990,
  },
];
